export { default } from "./Icon";
export type { IconData, IconProps } from "./Icon";
